import { addImageNotAvailable, buildApiImageUrl } from 'services/product-data.service';
import { DataResult } from 'models/data';
import { MetricsLoadingSpinner } from 'components/MetricsLoadingSpinner';
import { useParams } from 'react-router-dom';
import { useContext } from 'react';
import { TenantConfigContext } from 'context/TenantConfigContext';
import { EntityHeader } from 'pages/entities/components/EntityHeader';
import { AttributeCode } from 'services/model/model.service';
import { categoryLink, createArticleNameFromAttributes, productLink, styleLink } from 'pages/entities/entityhelper';
import { useIntl } from 'react-intl';

interface ProductDetailsSummaryProps {
  response: DataResult | null;
}

export function ArticleDetailsSummary({ response }: ProductDetailsSummaryProps) {
  const { articleEAN, tab } = useParams();
  const tenantContext = useContext(TenantConfigContext);

  const intl = useIntl();

  if (!response) {
    return <MetricsLoadingSpinner />;
  }

  const attributes = (response.attributes ?? {}) as Record<AttributeCode, string>;
  const imageUrl = attributes.artImageUrl ?? '';
  const productName = createArticleNameFromAttributes(attributes);

  return (
    <EntityHeader
      imageElement={
        <img
          src={buildApiImageUrl(tenantContext.accountNumber, imageUrl)}
          alt={productName}
          onError={addImageNotAvailable}
          className="w-full h-full !bg-snow-50"
        />
      }
      entity={'article'}
      entityDisplayName={createArticleNameFromAttributes(attributes)}
      boxedAttributes={[
        {
          attributeCode: 'prdCategory',
          attributeValue: attributes.prdCategory,
          link: categoryLink(attributes.prdCategory, tab),
        },
        {
          attributeCode: 'prdNumber',
          label: intl.formatMessage({ id: 'entities.name.singular.product' }),
          attributeValue: attributes.prdNumber,
          link: productLink(attributes.prdNumber ?? '', tab),
        },
        {
          attributeCode: 'styBrandColor',
          attributeValue: attributes.styBrandColor,
          link: styleLink(attributes.prdNumber ?? '', attributes.styBrandColor ?? '', tab),
        },
        { attributeCode: 'artEan', attributeValue: articleEAN },
        { attributeCode: 'prdSeason', attributeValue: attributes.prdSeason },
      ]}
    />
  );
}
